































import Vue from 'vue'
import PointsParticuliers from '@/components/SeismicInsepctionForm/_PointsParticuliers.vue'
import SeismicForm from '@/models/SeismicForm'

export default Vue.extend({
  name: 'InspectionCriteria4',
  components: {
    PointsParticuliers
  },
  props: {
    form: { type: [SeismicForm, Object] }
  },
  data () {
    return {
      specificPoints: [] as Array<string>
    }
  },
  beforeDestroy () {
    this.$emit('saveForm', this.form)
  },
  methods: {

  }
})

